import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBolt } from '@fortawesome/free-solid-svg-icons';

const ComposerHeader = ({
  hasOpenTickets,
  mergePillTitle,
  mergePillLabel,
  mergePromptMessage,
  displayQuickCommands = [],
  onShortcutClick,
  onOpenShortcutsModal,
  isDark
}) => {
  return (
    <div className="d-flex align-items-center justify-content-between px-3 pt-2 pb-1 flex-wrap gap-2">
      {/* Sección de Atajos */}
      <div className="d-flex align-items-center gap-1.5 flex-wrap">
        <span
          className="d-flex align-items-center gap-1"
          style={{
            fontSize: '0.78rem',
            color: isDark ? '#94a3b8' : '#64748b',
            fontWeight: 500
          }}
        >
          <FontAwesomeIcon icon={faBolt} style={{ color: '#f59e0b', fontSize: '0.76rem' }} />
          <span>Atajos:</span>
        </span>

        {hasOpenTickets && (
          <button
            type="button"
            title={mergePillTitle}
            onClick={() => onShortcutClick(mergePromptMessage)}
            className="btn btn-sm p-0 px-2 py-0.5 shadow-none"
            style={{
              fontSize: '0.74rem',
              fontWeight: 600,
              borderRadius: '16px',
              backgroundColor: '#fef3c7',
              color: '#b45309',
              border: '1px solid #fde68a'
            }}
          >
            {mergePillLabel}
          </button>
        )}

        {displayQuickCommands.map((cmd, idx) => {
          const label = cmd.vComando || cmd.label || '';
          const text = cmd.vTexto || cmd.text || '';
          const title = cmd.vTitulo || cmd.title || text;
          const cleanLabel = label.startsWith('/') ? label : `/${label}`;
          return (
            <button
              key={idx}
              type="button"
              title={title}
              onClick={() => onShortcutClick(text)}
              className="btn btn-sm p-0 px-2 py-0.5 shadow-none"
              style={{
                fontSize: '0.74rem',
                fontWeight: 500,
                fontFamily: 'monospace, sans-serif',
                borderRadius: '16px',
                backgroundColor: isDark ? '#1e293b' : '#f1f5f9',
                color: isDark ? '#cbd5e1' : '#475569',
                border: isDark ? '1px solid #334155' : '1px solid #e2e8f0',
                transition: 'all 0.15s ease'
              }}
            >
              {cleanLabel}
            </button>
          );
        })}

        <button
          type="button"
          title="Administrar o crear atajos"
          onClick={onOpenShortcutsModal}
          className="btn btn-sm p-0 px-2 py-0.5 shadow-none"
          style={{
            fontSize: '0.74rem',
            fontWeight: 500,
            borderRadius: '16px',
            backgroundColor: 'transparent',
            color: isDark ? '#94a3b8' : '#64748b',
            border: isDark ? '1px dashed #475569' : '1px dashed #cbd5e1',
            transition: 'all 0.15s ease'
          }}
        >
          + Atajo
        </button>
      </div>
    </div>
  );
};

ComposerHeader.propTypes = {
  hasOpenTickets: PropTypes.bool,
  mergePillTitle: PropTypes.string,
  mergePillLabel: PropTypes.string,
  mergePromptMessage: PropTypes.string,
  displayQuickCommands: PropTypes.array,
  onShortcutClick: PropTypes.func.isRequired,
  onOpenShortcutsModal: PropTypes.func.isRequired,
  isDark: PropTypes.bool
};

export default ComposerHeader;
